import { render, staticRenderFns } from "./FiltroRelatorioCobranca.vue.vue?vue&type=template&id=585dfb6c&lang=true&"
import script from "./FiltroRelatorioCobranca.vue.vue?vue&type=script&lang=js&"
export * from "./FiltroRelatorioCobranca.vue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports